<template>
	<v-tooltip bottom>
		<template v-slot:activator="{ on }">
			<v-btn
				v-if="!hide_button"
				:disabled="!selected_receipt.is_valid"
				class="ma-0"
				flat
				icon
				color="info"
				v-on="on"
				@click="checkRoomStateOld"
			>
				<v-icon class="zmdi zmdi-refresh-alt"></v-icon>
			</v-btn>
		</template>
		<span>Chuyển cọc</span>
		<v-dialog v-if="dialog" v-model="dialog" max-width="80%">
			<app-card>
				<app-section-loader
					:status="loading.submit"
				></app-section-loader>
				<h4>PHIẾU CHUYỂN CỌC</h4>
				<p class="fs-14 grey--text mb-1">
					Mã chứng từ hiện tại:
					<strong>{{ selected_receipt.receipt_id }}</strong>
				</p>
				<p class="fs-14 grey--text mb-1">
					Tòa nhà hiện tại:
					<strong>{{ selected_receipt.building }}</strong>
				</p>
				<p class="fs-14 grey--text mb-1">
					Số phòng hiện tại:
					<strong>{{ selected_receipt.room_id }}</strong>
				</p>
				<v-form ref="form">
					<v-container fluid>
						<v-layout row wrap justify-center>
							<v-flex xs12 md4>
								<v-select
									label="Tòa nhà mới:"
									:disabled="loading.submit"
									v-model="form.building_new"
									:items="list_building"
									prepend-icon="domain"
									:rules="requireText"
								></v-select>
							</v-flex>
							<v-flex xs12 md4>
								<v-select
									label="Số phòng mới:"
									:disabled="loading.submit"
									v-model="form.room_id_new"
									:items="room_ids"
									item-text="room_id"
									item-value="rooms_id"
									prepend-icon="meeting_room"
									:rules="requireText"
								></v-select>
							</v-flex>
                            <v-flex xs12 v-if="alert.show">
                                <v-alert
                                    :value="alert.show"
                                    :type="alert.type"
                                    outline
                                >
                                    {{ alert.text }}
                                </v-alert>
                            </v-flex>
							<v-flex v-if="!alert.show && form.room_id_new" xs12 md4>
								<v-text-field
									label="Giá phòng:"
									disabled
									v-model="form.room_price_old"
									prepend-icon="attach_money"
								>
									<template slot="append">
										VND
									</template>
								</v-text-field>
							</v-flex>
							<v-flex v-if="!alert.show && form.room_id_new" xs12>
								<v-text-field
									label="Ghi chú"
									:disabled="loading.submit"
									v-model="form.note"
									prepend-icon="event_note"
								>
								</v-text-field>
							</v-flex>
						</v-layout>
					</v-container>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn :disabled="loading.submit" @click="cancelInput"
							>Trở về</v-btn
						>
						<v-btn
							v-if="!alert.show"
							:loading="loading.submit"
							:disabled="loading.submit"
							@click="changeDeposit"
							dark
							color="green"
							>Tạo Phiếu Chuyển Cọc</v-btn
						>
					</v-card-actions>
				</v-form>
			</app-card>
		</v-dialog>
	</v-tooltip>
</template>
<script>
import api from "../../api";
export default {
	name: "chuyen-coc-component",
	props: {
		list_building: Array,
		selected_receipt: Object,
		trigger: Boolean,
		hide_button: { type: Boolean, default: false}
	},
	data() {
		return {
			dialog: false,
			loading: {
				submit: false
			},
			form: {
				building_new: "",
				room_id_new: "",
				room_price_old: "",
				note: ""
			},
			requireNumber: [
				v => !!v || "Vui lòng nhập thông tin này",
				v => /^[0-9]*$/.test(v.replace(/,/g, "")) || "Vui lòng nhập số"
			],
			requireText: [v => !!v || "Vui lòng nhập thông tin này"],
			requirePhone: [
				v => !!v || "Vui lòng nhập thông tin này",
				v => (v && v.length <= 10) || "SDT phải ngắn hơn 10 ký tự"
			],
			alert: {
                show: false,
                text: '',
                type: 'error'
            },
		};
	},
	computed: {
		rooms() {
			return this.$store.state.app.rooms;
		},
		room_ids() {
			return this.rooms.filter(
				room => room.building === this.form.building_new
			);
		}
	},
	watch: {
		dialog(nv){
			if (!nv) this.clearInput();
		},
		"form.building_new"(nv){
			if (nv) this.form.room_id_new = "";
		},
		"form.room_id_new"(nv){
			if (nv && this.form.building_new) this.checkRoomStateNew();
		},
        'form.room_price_old': function (nv, ov){
            this.form.room_price_old = nv ? nv.toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ''
		},
		trigger(){
			this.checkRoomStateOld()
		}
	},
	methods: {
		async checkRoomStateOld() {
			this.$store.commit("loading", true);
			const room_id = this.selected_receipt.room_id
			const data = await api.getRoomState(
				"roomId=" + room_id
			);
			if (data.status === 200 && data.data && data.data.roomState) {
				const room_state = data.data.roomState
				if (room_state.check_in_id){
					swal.fire('Lỗi', `Phòng ${room_id} đã nhận phòng nên không thể chuyển cọc`, 'info')
				} else {
					this.dialog = true
				}
			}
			this.$store.commit("loading", false);
		},
		async checkRoomStateNew(){
			this.alert.show = false;
			this.$store.commit("loading", true);
			const room_id = this.form.room_id_new;
			const data = await api.getRoomState("roomId=" + room_id);
			this.$store.commit("loading", false)
			if (data.status === 200) {
				const room_state = data.data.roomState;
				if (room_state && room_state.is_valid && !room_state.date_schedule_out){
					this.alert.show = true
                	this.alert.text = `Phòng ${room_id} đã có người ở`
				} else {
					const chosen_room =  this.rooms.find(room => room.room_id == this.form.room_id_new);
					this.form.room_price_old = chosen_room && chosen_room.room_price ? chosen_room.room_price : 2700000 
				}
			}
		},
		async changeDeposit() {
			this.loading.submit = true;
			const postData = {
				room_id_new: this.form.room_id_new,
				building_new: this.form.building_new,
				room_state_id_old: this.selected_receipt.room_state_id,
				receipt_id: this.selected_receipt.receipt_id,
				note: this.form.note,
            	room_price_old: Number(this.form.room_price_old.replace(/,/g, ''))
				};
			const data = await api.changeDeposit(postData);
			if (data.status == 200) {
				swal.fire("Thành công", 'Chuyển cọc thành công', "success");
				this.cancelInput();
				this.$emit("changeRoomId", this.selected_receipt.receipt_id, data.data)
			} else {
				swal.fire("Lỗi", data.message, "error");
			}
			this.loading.submit = false;
		},
		clearInput() {
			this.form = {
				building_new: "",
				room_id_new: ""
			};
			this.$refs.form.resetValidation();
		},
		cancelInput() {
			this.dialog = false;
			this.clearInput();
		}
	}
};
</script>